module.exports = __webpack_public_path__ + "public/img/在库.50999dcc.png";